import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import NotificationPopup from "../../../component/popup/NotificationPopup";

const UploadPDF = ({ onFileChange, uploadedPDF, readonly }) => {
    const [message, setMessage] = useState("");

    const handleDrop = (event) => {
        event.preventDefault();
        const files = event.dataTransfer.files;
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file && file.type === "application/pdf" && file.size > 0) {
                onFileChange(file);
            } else {
                setMessage(`Upload Failed: File "${file.name}" has an unsupported format.`);
            }
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
    };

    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
                sx={{
                    border: "1px #ccc dashed",
                    py: 1,
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <IconButton
                    disabled={readonly}
                    component="label"
                    sx={{
                        borderRadius: 0,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: "400px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        "&:hover": { backgroundColor: "transparent" },
                    }}
                >
                    <input
                        type="file"
                        accept=".pdf"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (file && file.type === "application/pdf" && file.size > 0) {
                                onFileChange(file);
                            } else if (file) {
                                setMessage(`Upload Failed: File "${file.name}" has an unsupported format.`);
                            }
                        }}
                        style={{ display: "none" }}
                    />
                    <img src="assets/buttons/uploadfile.svg" alt="uploadfile"></img>
                    {uploadedPDF
                        ? uploadedPDF.name ||
                        uploadedPDF.filename ||
                        "Click or Drag to upload pdf"
                        : "Click or Drag to upload pdf"}
                </IconButton>
            </Box>
            <NotificationPopup
                open={!!message}
                onClose={() => setMessage("")}
                title="Warning"
                message={message}
                iconSrc="assets/icons/error.svg"
                buttonLabel="Close"
                variant="error"
            />
        </Box>
    );
};

export default UploadPDF;
